import {Directive, ElementRef, HostBinding, OnInit} from '@angular/core';
import {AuthorizationService} from '@core/security/services/authorization.service';
import {RoleEnum} from '@core/security/enum/role.enum';

@Directive({
    selector: '[appContentShield]',
})
export class ContentShieldDirective implements OnInit {
    @HostBinding('style.user-select')
    private disableTextSelection?: string;

    @HostBinding('class.content-shield')
    private disableTextSelectionWebkit?: boolean;

    public constructor(private elementRef: ElementRef, private authorizationService: AuthorizationService) {
    }

    public ngOnInit(): void {
        if (!this.authorizationService.isGranted(RoleEnum.RoleOrganizationHo)) {
            return;
        }

        const element: HTMLElement = this.elementRef.nativeElement;

        this.disableTextSelection = 'none';
        this.disableTextSelectionWebkit = true;
        element.addEventListener('contextmenu', event => this.handleContextMenuEvent(event));
    }

    private handleContextMenuEvent(event: Event): void {
        const eventTargetElement: EventTarget | null = event.target;

        if (null !== eventTargetElement && (this.isTextArea(eventTargetElement) || EventTarget instanceof HTMLInputElement)) {
            return;
        }

        event.preventDefault();
    }

    private isTextArea(element: EventTarget): boolean {
        return null !== (element as HTMLElement).closest('.document__textarea');
    }
}
